export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--X.c936debf.png";